// The homepage "top items" carousel. The homepage route builds its ItemList
// structured data from this same array, so the schema can't drift from the
// cards people actually see (it once listed a croissant that was no longer sold).
//
// Photos come from the synced Toast image map by title (pages/home.tsx looks
// them up), so titles must match the menu's item names exactly. Don't import
// the image map here: the homepage route's head() imports this file, and
// route heads ship in the entry chunk every page loads.
export const TOP_TOAST_ITEMS = [
  {
    title: "Mexican Sidecar",
    tag: "Top Coffee",
    description: "Espresso, horchata, cinnamon, and whiskey brown sugar syrup.",
    price: "$6.50",
  },
  {
    title: "Strawberry Matcha Latte",
    tag: "Top Matcha",
    description: "Matcha, milk, strawberry compote, and simple syrup.",
    price: "$7.95",
  },
  {
    title: "Spanish Latte",
    tag: "Top Coffee",
    description: "Espresso, milk, honey, and cinnamon. Lightly sweet, no condensed milk.",
    price: "$6.50",
  },
  {
    title: "Matcha Latte",
    tag: "Top Matcha",
    description: "Matcha, milk, and simple syrup.",
    price: "$5.95",
  },
  {
    title: "Garlic Cream Cheese Salt Bread",
    tag: "New Bakery",
    description: "Buttery salt bread topped with garlic cream cheese.",
    price: "$3.95",
  },
  {
    title: "Cookie Butter Latte",
    tag: "Top Coffee",
    description: "Espresso, milk, and cookie butter syrup.",
    price: "$6.50",
  },
  {
    title: "Sea Salt Walnut Cookies",
    tag: "Top Bakery",
    description: "Cookies with walnuts and sea salt.",
    price: "$4.00",
  },
  {
    title: "Double Ube Salt Bread",
    tag: "New Bakery",
    description: "Purple ube salt bread, sweet and buttery.",
    price: "$3.95",
  },
  {
    title: "Pandan Kaya Salt Bread",
    tag: "New Bakery",
    description: "Pandan salt bread with kaya, a sweet coconut jam.",
    price: "$3.95",
  },
  {
    title: "Pandan Latte",
    tag: "Top Coffee",
    description: "Espresso, milk, and pandan syrup.",
    price: "$6.50",
  },
] as const
